<div class="popup-notification__container">
  <bfx-popup-notification
    *ngFor="let popup of popupNotifications"
    [data]="popup"
  ></bfx-popup-notification>
</div>
